// extracted by mini-css-extract-plugin
export var bodySections = "_dv-8";
export var gray = "_dv-7";
export var green = "_dv-4";
export var iconContainer = "_dv-9";
export var iconWidgetContainer = "_dv-1";
export var phoneIcon = "_dv-2";
export var red = "_dv-5";
export var statusDot = "_dv-3";
export var widgetContainer = "_dv-0";
export var yellow = "_dv-6";